import { scopedT } from 'utils/functions/Translations';

const t = scopedT();

export const toggleGroupHeaderOverride: { [key: string]: string } = {
  [t('core.sharedWith')]: t('core.sharedVisibility'),
  [t('filter.identifierType.billOfLading')]: t(
    'filter.identifierType.additionalIdentifier',
  ),
};

export const toggleGroupConfig: {
  [key: string]: Array<{
    id: string;
    label: string;
  }>;
} = {
  destination: [
    { id: 'destination', label: t('core.destinationLocationName') },
    { id: 'est-act-arrival', label: t('core.arrivalTime') },
    { id: 'planned-arrival', label: t('core.plannedArrival') },
  ],
  'shared-with': [
    { id: 'shared-with', label: t('core.sharedWith') },
    { id: 'visibility-provided', label: t('core.visibilityProvidedBy') },
  ],
  'poo-port-name': [
    { id: 'poo-port-name', label: t('core.portCode') },
    { id: 'poo-departure-time', label: t('sort.departureTime') },
    { id: 'poo-planned-departure', label: t('sort.plannedDeparture') },
  ],
  'pod-port-name': [
    { id: 'pod-port-name', label: t('core.portCode') },
    { id: 'pod-est-act-arrival', label: t('sort.dischargeTime') },
    { id: 'pod-planned-arrival', label: t('sort.plannedDischarge') },
  ],
  origin: [
    { id: 'origin', label: t('core.originLocationName') },
    { id: 'est-act-departure', label: t('core.departureTime') },
    { id: 'planned-departure', label: t('core.plannedDeparture') },
  ],
  'bill-of-lading': [
    { id: 'bill-of-lading', label: t('filter.identifierType.billOfLading') },
    {
      id: 'house-bill-of-lading',
      label: t('filter.identifierType.houseBillOfLading'),
    },
    { id: 'booking-number', label: t('filter.identifierType.bookingNumber') },
    { id: 'serial-number', label: t('filter.identifierType.serialNumber') },
    {
      id: 'vehicle-identification-number',
      label: t('filter.identifierType.vehicleIdentificationNumber'),
    },
    { id: 'order-number', label: t('filter.identifierType.orderNumber') },
    { id: 'pro-number', label: t('filter.identifierType.proNumber') },
    { id: 'tracking-number', label: t('filter.identifierType.trackingNumber') },
    { id: 'air-waybill', label: t('filter.identifierType.airWaybill') },
    {
      id: 'house-airwaybill',
      label: t('filter.identifierType.houseAirWaybill'),
    },
    { id: 'railcar-id', label: t('filter.identifierType.railCarId') },
    { id: 'waybill', label: t('filter.identifierType.waybill') },
    { id: 'train-number', label: t('filter.identifierType.trainNumber') },
    { id: 'wagon-id', label: t('filter.identifierType.wagonId') },
    { id: 'container-id', label: t('filter.identifierType.containerId') },
  ],
};

export const sortConfig: { [key: string]: string[] } = {
  origin: ['est-act-departure', 'planned-departure'],
  destination: ['est-act-arrival', 'planned-arrival'],
  'shared-with': ['visibility-provided'],
  'poo-port-name': ['poo-departure-time', 'poo-planned-departure'],
  'pod-port-name': ['pod-est-act-arrival', 'pod-planned-arrival'],
  'bill-of-lading': [
    'house-bill-of-lading',
    'booking-number',
    'serial-number',
    'vehicle-identification-number',
    'order-number',
    'pro-number',
    'tracking-number',
    'air-waybill',
    'house-airwaybill',
    'railcar-id',
    'waybill',
    'train-number',
    'wagon-id',
    'container-id',
  ],
};

export const getFilterGroup = () => {
  let next: string[] = [];
  for (const key in toggleGroupConfig) {
    const config = toggleGroupConfig[key].filter(({ id }) => id !== key);
    next = next.concat(config.map(({ id }) => id));
  }
  return next;
};

export const getActiveToggleGroup = (toggleOptions: string[]) => {
  const op: { [key: string]: string[] } = {};
  for (const key in toggleGroupConfig) {
    const ids = toggleGroupConfig[key].map(({ id }) => id);
    op[key] = ids.filter((id) => toggleOptions.includes(id));
  }
  return op;
};

export const getToggleGroup = () => {
  const op: { [key: string]: string[] } = {};
  for (const key in toggleGroupConfig) {
    op[key] = toggleGroupConfig[key].map(({ id }) => id);
  }
  return op;
};
